export default __webpack_public_path__ + "static/media/NoteEditIcon.42ee0f01.svg";